/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Already_Billed_TooltipInputs */



/**
* | output |
* | --- |
* | "Large usage is invoiced during the billing period, not only at the end, so it doesn't all land on one invoice. Charged amounts are rounded up to the nearest ..." |
*
* @param {Dashboard_Billing_Already_Billed_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_already_billed_tooltip = /** @type {((inputs?: Dashboard_Billing_Already_Billed_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Already_Billed_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hohe Nutzung wird bereits während der Abrechnungsperiode in Rechnung gestellt, nicht erst am Ende, so sammelt sich nicht alles auf einer Rechnung. Abgerechnete Beträge werden auf den nächsten Cent aufgerundet.")
	return /** @type {LocalizedString} */ ("Large usage is invoiced during the billing period, not only at the end, so it doesn't all land on one invoice. Charged amounts are rounded up to the nearest cent.")
});